import React from 'react';
import { motion } from 'framer-motion';
export function WhoIsForSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-338">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-339">
        {/* Who it is for */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#070B16] p-8 rounded-2xl border-t-4 border-[#F6C65B] shadow-lg" data-id="element-340">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-341">
            Este protocolo puede ser para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-342">
            {['Sientes más el zumbido al acostarte.', 'Te frustras cuando todo queda en silencio.', 'Has probado ruido blanco sin resultados duraderos.', 'Quieres una rutina simple y práctica.', 'Buscas calmar tu reacción mental al sonido.', 'Quieres dejar de revisar constantemente si el zumbido sigue ahí.'].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-343">
                <span className="text-[#F6C65B] mt-1" data-id="element-344">✓</span>
                <span data-id="element-345">{text}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Who it is NOT for */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#070B16] p-8 rounded-2xl border-t-4 border-red-500 shadow-lg" data-id="element-346">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-347">
            Para quién NO es:
          </h3>
          <ul className="space-y-4" data-id="element-348">
            {['Personas con pérdida auditiva súbita o dolor agudo (deben ver a un médico de inmediato).', "Quienes buscan una 'pastilla mágica' que elimine el sonido sin cambiar sus hábitos nocturnos.", 'Tinnitus causado por infecciones activas que requieren tratamiento antibiótico.'].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-349">
                <span className="text-red-500 mt-1" data-id="element-350">✕</span>
                <span data-id="element-351">{text}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}